const styles = {
  container: {
    width: '100%',
    flexDirection: 'column',
    justifyContent: 'space-between',
    display: 'flex',
    padding: '8px 16px',
    boxSizing: 'border-box',
  },
  fullHeight: {
    flexGrow: 1,
  },
};

export default styles;
